import { useContext, useEffect, useState } from "react"
import { CustomContainer } from "src/style"
import utility from "src/utils/utility"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import './style.scss'

const About: React.FC = () => {
    const {loader} = useContext(VisibilityContext)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        window.location.href = "https://qore.inc/q-store-pending"
        //loader(isLoading)
    }, [isLoading])

    return (
        <CustomContainer>
            {/* <iframe
                src="https://qore.inc/q-store-pending"
                className="about-container"
                title="About Site"
                onLoad={() => setIsLoading(false)}
            /> */}
        </CustomContainer>
    )
}

export default utility.routeData('about', 'About', <About/>)